import { trackingDataApis } from '@apis/dashboard/trackingDataApis';
import { createUseQuery } from '@hooks/createUseQuery';

export const useTrackingData = createUseQuery(
  (trackNo: string) => ['/dashboard/tracking-data/', trackNo],
  (trackNo) => () =>
    trackingDataApis
      .get('/dashboard/tracking-data/{track_no}/', {
        path: { track_no: trackNo },
      })
      .then((r) => r[200] ?? r[404]),
);
